import React from 'react'

import {
  Grid,
  Panel,
  Alert,
  FlexBox,
  Columns,
  IconFont,
  CTAButton,
  AppWrapper,
  FunnelPage,
  AlignItems,
  FlexDirection,
  ComponentSize,
  ComponentColor,
} from '@influxdata/clockface'

import InfluxDataLogo from 'js/components/InfluxDataLogo'
import FunnelHeader from '../shared/FunnelHeader'
import FunnelSubheader from '../shared/FunnelSubheader'
import {createAccount} from 'js/client'

const handleContinue = async (): Promise<void> => {
  try {
    await createAccount()
    window.location.href = '/splash'
  } catch (error) {
    console.error(error)
  }
}

const UserWithoutAccount = (): JSX.Element => {
  return (
    <AppWrapper type="funnel">
      <FunnelPage logo={<InfluxDataLogo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <FlexBox
              direction={FlexDirection.Column}
              alignItems={AlignItems.Center}
              margin={ComponentSize.Large}
            >
              <FunnelHeader text="Organization not found" />
              <FunnelSubheader text="You must be in at least one organization to use InfluxDB Cloud" />
              <Alert
                color={ComponentColor.Warning}
                icon={IconFont.AlertTriangle}
                style={{textAlign: 'left'}}
              >
                You are not currently in any organization
              </Alert>
              <Panel className="invite-org-error">
                <Panel.Body size={ComponentSize.Large}>
                  <p>
                    Click the link below to set up your organization or contact
                    your organization admin to request a new invite link.
                  </p>
                </Panel.Body>
              </Panel>
              <p>
                Next: <strong>Set up your organization</strong>
              </p>
              <CTAButton
                color={ComponentColor.Primary}
                text="Continue"
                onClick={handleContinue}
              />{' '}
              <p>
                Issues?
                <br />
                Talk to{' '}
                <a href="mailto:support@influxdata.com" target="_blank">
                  support@influxdata.com
                </a>
              </p>
            </FlexBox>
          </Grid.Column>
        </Grid.Row>
      </FunnelPage>
    </AppWrapper>
  )
}

export default UserWithoutAccount
